import { Routes, Route } from 'react-router-dom'
import { useTranslation } from 'react-i18next'
import { useEffect, useState } from 'react'
import { supabase } from './lib/supabase'
import { WizardPage } from './pages/WizardPage'
import { PrivacyPage } from './pages/PrivacyPage'
import { PlanPage } from './pages/PlanPage'
import { AuthPage } from './pages/AuthPage'
import { SavedPlansPage } from './pages/SavedPlansPage'
import { AccountPage } from './pages/AccountPage'
import { AdminPage } from './pages/AdminPage'
import { LandingPage } from './pages/LandingPage'
import { AffiliatePage } from './pages/AffiliatePage'

function App() {
  const [user, setUser] = useState<any>(null)
  const [openPremium, setOpenPremium] = useState(false)
  const { t } = useTranslation()
  const [cookieAccepted, setCookieAccepted] = useState(() => localStorage.getItem('cookie_consent') === 'true')
  const handleAcceptCookies = () => { localStorage.setItem('cookie_consent', 'true'); setCookieAccepted(true) }

  const [profile, setProfile] = useState<any>(null)
  const [loading, setLoading] = useState(true)

  const loadProfile = async (userId: string) => {
    const { data } = await supabase.from('users').select('*').eq('id', userId).single()
    setProfile(data)
  }

  useEffect(() => {
    supabase.auth.getSession().then(({ data }) => {
      const u = data.session?.user ?? null
      setUser(u)
      if (u) loadProfile(u.id)
      setLoading(false)
    })
    const { data: { subscription } } = supabase.auth.onAuthStateChange((_event: any, session: any) => {
      const u = session?.user ?? null
      setUser(u)
      if (u) {
        loadProfile(u.id)
        if (localStorage.getItem('open_premium_after_login')) {
          localStorage.removeItem('open_premium_after_login')
          setOpenPremium(true)
        }
      }
    })
    return () => subscription.unsubscribe()
  }, [])

  useEffect(() => {
    const params = new URLSearchParams(window.location.search)
    if (params.get('open') === 'premium') {
      window.history.replaceState({}, '', '/')
      setOpenPremium(true)
    }
    const ref = params.get('ref')
    if (ref) {
      localStorage.setItem('affiliate_ref', ref)
      supabase.from('affiliate_clicks').insert({ code: ref }).then(() => {})
      supabase.from('affiliates').select('clicks').eq('code', ref).single().then(({ data }) => {
        if (data) supabase.from('affiliates').update({ clicks: (data.clicks || 0) + 1 }).eq('code', ref).then(() => {})
      })
    }
  }, [])

  useEffect(() => {
    const params = new URLSearchParams(window.location.search)
    if (params.get('premium') === 'success') {
      window.history.replaceState({}, '', '/')
      const poll = setInterval(async () => {
        const { data: { session } } = await supabase.auth.getSession()
        if (session?.user) {
          const { data } = await supabase.from('users').select('is_premium').eq('id', session.user.id).single()
          if (data?.is_premium) {
            setProfile((prev: any) => ({ ...prev, is_premium: true }))
            clearInterval(poll)
          }
        }
      }, 2000)
      setTimeout(() => clearInterval(poll), 30000)
    }
  }, [])

  if (loading) return (
    <div style={{ minHeight: '100vh', display: 'flex', alignItems: 'center', justifyContent: 'center', backgroundColor: '#F8F9FA' }}>
      <div style={{ width: 40, height: 40, borderRadius: '50%', border: '3px solid #1c3fff', borderTopColor: 'transparent' }} />
    </div>
  )

  const isPremium = profile?.is_premium === true

  return (
    <div style={{ minHeight: '100vh', backgroundColor: '#F8F9FA' }}>
      <Routes>
        <Route path="/" element={user ? <WizardPage user={user} isPremium={isPremium} openPremium={openPremium} onPremiumOpened={() => setOpenPremium(false)} /> : <LandingPage user={user} />} />
        <Route path="/app" element={<WizardPage user={user} isPremium={isPremium} openPremium={openPremium} onPremiumOpened={() => setOpenPremium(false)} />} />
        <Route path="/plan" element={<PlanPage user={user} isPremium={isPremium} />} />
        <Route path="/auth" element={<AuthPage />} />
        <Route path="/plans" element={<SavedPlansPage user={user} isPremium={isPremium} />} />
        <Route path="/account" element={<AccountPage user={user} isPremium={isPremium} />} />
        <Route path="/admin" element={<AdminPage user={user} />} />
        <Route path="/affiliato/:code" element={<AffiliatePage />} />
        <Route path="/privacy" element={<PrivacyPage />} />
      </Routes>
      {!cookieAccepted && (
        <div style={{ position: 'fixed', bottom: 0, left: 0, right: 0, backgroundColor: '#111827', color: 'white', padding: '16px 24px', display: 'flex', alignItems: 'center', justifyContent: 'space-between', zIndex: 9999, flexWrap: 'wrap', gap: 12 }}>
          <p style={{ margin: 0, fontSize: 13, color: '#D1D5DB', maxWidth: 600 }}>
            {t('cookie.text')} <a href="/privacy" style={{ color: '#60A5FA' }}>{t('cookie.privacy')}</a>.
          </p>
          <div style={{ display: 'flex', gap: 8 }}>
            <button onClick={handleAcceptCookies} style={{ backgroundColor: '#1c3fff', color: 'white', border: 'none', borderRadius: 8, padding: '8px 20px', cursor: 'pointer', fontWeight: 600, fontSize: 13 }}>{t('cookie.accept')}</button>
            <button onClick={() => setCookieAccepted(true)} style={{ backgroundColor: '#374151', color: 'white', border: 'none', borderRadius: 8, padding: '8px 20px', cursor: 'pointer', fontSize: 13 }}>{t('cookie.necessary')}</button>
          </div>
        </div>
      )}
    </div>
  )
}

export default App
